export const getCookie = (name: string) => {
  // this is a regex that creates two capturing groups...
  // the things in parantheses.

  const cookieRegex = new RegExp(`(^| )${name}=([^;]+)`);

  // those get captured by the match in an array
  const cookie = document.cookie.match(cookieRegex);

  // or if no matches exist, it's just undefined.
  if (!cookie) {
    return undefined;
  }

  // but if they do, array!
  // i don't know why, but the array goes:
  // [  0: match 1,
  //    1: an empty string
  //    2: match 2 (the data we want!) ]
  // but im not gonna change it and break it.
  return cookie[2];
};

export const getXsrfToken = () => getCookie('XSRF-TOKEN');
